export default "__VITE_ASSET__CRCOah2Z__"